import { render } from "./WorkMediaOther.vue?vue&type=template&id=6047e66a"
import script from "./WorkMediaOther.vue?vue&type=script&lang=js"
export * from "./WorkMediaOther.vue?vue&type=script&lang=js"

import "./WorkMediaOther.vue?vue&type=style&index=0&id=6047e66a&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__